import React, { useState } from 'react';
import { useQuery } from 'react-query';
import DF from 'DisplayFramework';
import Text from 'antd/lib/typography/Text';
import {
  getSynthesis,
} from 'services/workflow';

import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import { List } from 'antd';
import { toCurrency } from 'utils/utils';
export type SynthesListProps = {
  objecttype: string;
  objectid: number;
  currcode?:string;
};

const SynthesList = ({ objecttype, objectid,currcode }: SynthesListProps) => {
  const searchParams = {
    objecttype: objecttype,
    objectid: objectid,
  };
  const { data} = useQuery(
    ['getSynthesis', searchParams],
    () => getSynthesis(searchParams).then((res) => res.list || [])
  );

  const [visible, setVisible] = useState({
    ThirdpartyVisible: false,
    CinvoiceVisible: false,
    SinvoiceVisible: false,
    ProposalVisible: false,
  });

  return (
    <DF.Provider pagcode="synthesliste">
      
      <List
        size="large"
        style={{margin:'10px',marginTop:'50px'}}
        bordered
        dataSource={data ?? []}
        renderItem={(item) => {
          return (
            <List.Item >
              <Text
                style={{
                  color: item.syncolor,
                  fontSize: item.synfontsize,
                }}
              >
                {item.synlabel}
              </Text>

              {data! ? (
                item.syndisplay === 'TEXT' ? (
                  item.syntargetobject !== 'PARLIST' ? (
                    <Text
                      style={{
                        color: item.syncolor,
                        fontSize: item.synfontsize,
                      }}
                    >
                      {item.synvalue}
                    </Text>
                  ) : (
                    <Text
                      style={{
                        color: item.syncolor,
                        fontSize: item.synfontsize,
                      }}
                    >
                      {item.synvaluelabel}
                    </Text>
                  )
                ) : item.syndisplay === 'LINK' ? (
                  <>
                    <a
                      style={{
                        color: item.syncolor,
                        fontSize: item.synfontsize,
                      }}
                      onClick={(e) => {
                        if (item.syntargetobject === 'PROPOSAL')
                          setVisible({ ...visible, ProposalVisible: true });
                        else if (item.syntargetobject === 'THIRDPARTY')
                          setVisible({ ...visible, ThirdpartyVisible: true });
                        if (item.syntargetobject === 'CINVOICE')
                          setVisible({ ...visible, CinvoiceVisible: true });
                        if (item.syntargetobject === 'SINVOICE')
                          setVisible({ ...visible, SinvoiceVisible: true });
                      }}
                    >
                      {item.synvalue}
                    </a>
                    {item.syntargetobjectid && item.syntargetobject === 'PROPOSAL' && (
                      <ProposalModal
                        showAsModal
                        ctrid={item.syntargetobjectid}
                        visible={visible.ProposalVisible}
                        onCancel={() =>
                          setVisible({ ...visible, ProposalVisible: false })
                        }
                        onSuccess={() =>
                          setVisible({ ...visible, ProposalVisible: false })
                        }
                        title=""
                      />
                    )}
                    {item.syntargetobjectid && item.syntargetobject === 'THIRDPARTY' && (
                      <ThirdPartyModal
                        tpId={item.syntargetobjectid}
                        visible={visible.ThirdpartyVisible}
                        onCancel={() =>
                          setVisible({ ...visible, ThirdpartyVisible: false })
                        }
                        onSuccess={() =>
                          setVisible({ ...visible, ThirdpartyVisible: false })
                        }
                        title=""
                      />
                    )}
                    { item.syntargetobjectid && item.syntargetobject === 'CINVOICE' && (
                      <CIDetail
                        ciid={item.syntargetobjectid}
                        onCancel={() =>
                          setVisible({ ...visible, CinvoiceVisible: false })
                        }
                        showAsModal
                        visible={visible.CinvoiceVisible}
                      />
                    )}
                    {item.syntargetobjectid && item.syntargetobject === 'SINVOICE' && (
                      <SIDetail
                        siid={item.syntargetobjectid}
                        onCancel={() =>
                          setVisible({ ...visible, SinvoiceVisible: false })
                        }
                        showAsModal
                        visible={visible.SinvoiceVisible}
                      />
                    )}
                  </>
                ) : (
                  //modal controller sinon theres already existed modal so check them
                  <Text
                    style={{
                      color: item.syncolor,
                      fontSize: item.synfontsize,
                    }}
                  >
                        {toCurrency(item.synvalue, currcode)}
                     
                  </Text>
                )
              ) : (
                ''
              )}
            </List.Item>
          );
        }}
      />
    </DF.Provider>
  );
};

export default SynthesList;
